import { render, staticRenderFns } from "./workplace.vue?vue&type=template&id=8c20d694&scoped=true"
import script from "./workplace.vue?vue&type=script&lang=js"
export * from "./workplace.vue?vue&type=script&lang=js"
import style0 from "./workplace.vue?vue&type=style&index=0&id=8c20d694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c20d694",
  null
  
)

export default component.exports